import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
// import indexMiddleware from '../middleware/indexMiddleware';
// import tlwIndexMiddleware from '../middleware/tlwIndexMiddleware';
// import headerMiddleware from '../middleware/headerMiddleware';
// import footerMiddleware from '../middleware/footerMiddleware';
import memberMiddleware from '../middleware/memberMiddleware';
// import productMiddleware from '../middleware/productMiddleware';
// import categoryMiddleware from '../middleware/categoryMiddleware';
// import flagshipMiddleware from '../middleware/flagshipMiddleware';
import cartMiddleware from '../middleware/cartMiddleware';
import shoppingInfoMiddleware from '../middleware/shoppingInfoMiddleware';
// import instantProductMiddleware from '../middleware/instantProductMiddleware';
// import searchPageMiddleware from '../middleware/searchPageMiddleware';
import orderListMiddleware from '../middleware/orderListMiddleware';
import orderDetailMiddleware from '../middleware/orderDetailMiddleware';

import reducers from '../reducers';

const enhancer = applyMiddleware(
  // headerMiddleware,
  // footerMiddleware,
  // indexMiddleware,
  // tlwIndexMiddleware,
  memberMiddleware,
  // productMiddleware,
  // categoryMiddleware,
  // flagshipMiddleware,
  cartMiddleware,
  shoppingInfoMiddleware,
  // instantProductMiddleware,
  // searchPageMiddleware,
  orderListMiddleware,
  orderDetailMiddleware,
  thunk,
);

export default createStore(
  reducers,
  composeWithDevTools(
    enhancer,
    // other store enhancers if any
  ),
);
